import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default () => {

    const swipers = document.querySelectorAll('.homepage-cards-swiper');
    if (!swipers.length) {
        return;
    }

    swipers.forEach((swiperEl,index) => {

        const allSlides = swiperEl.querySelectorAll('.swiper-slide');

        if (!allSlides.length) {
            return;
        }

        const swiperOpts = {
            /* modules: [Navigation], */
            spaceBetween: 24,
            loop: false,
            speed: 600,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.homepage-cards-swiper-button-next',
                prevEl: '.homepage-cards-swiper-button-prev',
            },
        };

        const homepageCardsSwiper = new Swiper('.homepage-cards-swiper', swiperOpts);

    });

}